var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title',[_vm._v("历史发货记录")]),_vm._v(" "),_c('section',{staticClass:"mainPart"},[_c('CompanyTab',{attrs:{"active":_vm.currentTit}}),_vm._v(" "),_c('ShipmentRecord',{attrs:{"recordType":1}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ce8a43e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/OrderFolder/StoreSale/HistoricalShipmentRecords.vue
// module id = null
// module chunks = 